// extracted by mini-css-extract-plugin
export default {"catalogContainer":"CatalogContainer_catalogContainer__PSy5j","sortMobileFilter":"CatalogContainer_sortMobileFilter__58-un"};